import { render, staticRenderFns } from "./FFormAttachment.vue?vue&type=template&id=1b4e9456&scoped=true&"
import script from "./FFormAttachment.vue?vue&type=script&lang=js&"
export * from "./FFormAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4e9456",
  null
  
)

export default component.exports